import request from '@/utils/request';

export default{
  //新增设备模板
  addDeviceTemplate(postData){
    return request.post('/devicetemplate/insertDeviceTemplate', postData);
  },
  //查询设备模板
  getDeviceTemplate(opt) {
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/queryDeviceTemplate', {
      params: params
    });
  },
  //修改设备模板
  editDeviceTemplate(postData){
    return request.post('/devicetemplate/updateDeviceTemplate', postData);
  },
  //删除设备模板
  deleteDeviceTemplate(opt) {
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/deleteDeviceTemplate', {
      params: params
    });
  },
  //查询模板页面列表
  getTemplateList(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/queryTemplate',{
      params: params
    });
  },
  //查询上传的变量
  getUploadValue(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/returnTemplateVariables',{
      params: params
    });
  },
  //保存或修改设备模板
  saveDeviceTemplate(postData){
    return request.post('/devicetemplate/saveCanvas', postData);
  },
  //获取设备模板
  getTemplate(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/returnCanvas',{
      params: params
    });
  },
  //发送消息
  sendInfo(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/sendMessageQueryData',{
      params: params
    });
  },
  //获取所有文件夹
  getFolder(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/queryFolder',{
      params: params
    });
  },
  //新增文件夹
  addFolder(postData){
    return request.post('/devicetemplate/insertFolder', postData);
  },
  //修改文件夹名称
  editFolder(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/updateFolder',{
      params: params
    });
  },
  //删除文件夹
  deleteFolder(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/deleteFolder',{
      params: params
    });
  },
  //删除图片
  deleteImage(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/deletePictures',{
      params: params
    });
  },
  //复制模板
  copyTemplate(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/copyParentCanvas',{
      params: params
    });
  },
  //设置默认模板
  defaultTemplate(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/setDefaultCanvas',{
      params: params
    });
  },
  //复制子模板
  copySubTemplate(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/copyCanvas',{
      params: params
    });
  },
  //删除子模板
  deleteSubTemolate(opt){
    const params = {
      ...opt
    }
    return request.delete('/devicetemplate/deleteCanvas',{
      params: params
    });
  },
  //获取子模板
  getSubTemolate(opt){
    const params = {
      ...opt
    }
    return request.get('/devicetemplate/querySubPage',{
      params: params
    });
  },
  //新增组件
  insertComponent(postData){
    return request.post('/devicetemplate/insertComponent', postData);
  },
  //删除组件
  deleteComponent(opt){
    const params = {
      ...opt
    }
    return request.delete('/devicetemplate/deleteComponent',{
      params: params
    });
  },
  //获取表格数据
  getTableData(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryTableData',{
      params: params
    });
  },
  //新增终端
  addLowerEndDevice(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/addLowerEndDevice',{
      params: params
    });
  },
  //修改终端
  updateLowerEndDevice(postData){
    return request.post('/projectsite/updateLowerEndDevice', postData);
  },
  //查询终端
  queryLowerEndDevice(opt){
    const params = {
      ...opt
    }
    return request.get('/projectsite/queryLowerEndDevice/'+ opt.page + '/' + opt.size,{
      params: params
    });
  },
  //删除终端
  deleteLowerEndDevice(opt){
    const params = {
      ...opt
    }
    return request.delete('/projectsite/deleteLowerEndDevice',{
      params: params
    });
  },
}